import { render, staticRenderFns } from "./noticiasComponente.html?vue&type=template&id=7fe2f173&scoped=true&"
import script from "./noticiasComponente.ts?vue&type=script&lang=ts&"
export * from "./noticiasComponente.ts?vue&type=script&lang=ts&"
import style0 from "./noticiasComponente.scss?vue&type=style&index=0&id=7fe2f173&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe2f173",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
